var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f2f6ff;\n        stroke: #f2f6ff;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .st1 {\n        fill: #2569f2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32,
    cy: 32,
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.21,35.04h0c-.24.01-1.46.08-4.17.08-2.17,0-3.69-.06-4.23-.09h0c-8.35-.36-14.57-1.81-14.57-3.56s6.23-3.19,14.57-3.56v5.68c.54.04,2.11.13,4.27.13,2.59,0,3.89-.11,4.13-.13v-5.67c8.33.37,14.54,1.82,14.54,3.56s-6.21,3.19-14.54,3.56M36.21,27.34v-5.08h11.62v-7.74h-31.64v7.74h11.62v5.08c-9.45.43-16.55,2.3-16.55,4.54s7.1,4.11,16.55,4.55v16.28h8.4v-16.28c9.43-.43,16.52-2.3,16.52-4.54s-7.09-4.11-16.52-4.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.23f049cf7ffbd70aa4d7a84fab030c41.svg";
export { ForwardRef as ReactComponent };